import { actionColumns } from "../../../utils/columns";

export const INITIAL_STATE = {
  sortFilter: actionColumns.DATES.key,
  sortDirection: actionColumns.DATES.sortDirection,
  activeColumns: {
    [actionColumns.ID.key]: true,
    [actionColumns.PRIORITY.key]: true,
    [actionColumns.SITE.key]: true,
    [actionColumns.SUMMARY.key]: true,
    [actionColumns.CONTEXT.key]: true,
    [actionColumns.RESPONSIBLE.key]: true,
    [actionColumns.DATES.key]: true,
    [actionColumns.STATUS.key]: true,
  },
  // NOTE: Temporary filter for conditionally excluding non-pending issues as an admin for presentations
  includeOpenStatus: false,
};

const ACTIONS_UI_UPDATE_SORT = "bonfire/actionsUI/ACTIONS_UI_UPDATE_SORT";
const ACTIONS_UI_UPDATE_ACTIVE_COLUMNS =
  "bonfire/actionsUI/ACTIONS_UI_UPDATE_ACTIVE_COLUMNS";
export const ACTIONS_UI_TOGGLE_INCLUDE_OPEN_STATUS =
  "bonfire/actionsUI/ACTIONS_UI_TOGGLE_INCLUDE_OPEN_STATUS";

export function updateSortFunc(sortFuncKey) {
  return {
    type: ACTIONS_UI_UPDATE_SORT,
    sortFuncKey,
  };
}

export function updateActiveColumns(column) {
  return {
    type: ACTIONS_UI_UPDATE_ACTIVE_COLUMNS,
    column,
  };
}

export const toggleIncludeOpenIssues = () => ({
  type: ACTIONS_UI_TOGGLE_INCLUDE_OPEN_STATUS,
});

export function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTIONS_UI_UPDATE_SORT: {
      if (state.sortFilter === action.sortFuncKey) {
        return {
          ...state,
          sortDirection: state.sortDirection === "asc" ? "desc" : "asc",
        };
      }

      return {
        ...state,
        sortFilter: action.sortFuncKey,
        sortDirection: actionColumns[action.sortFuncKey].sortDirection,
      };
    }
    case ACTIONS_UI_UPDATE_ACTIVE_COLUMNS: {
      // Toggle value of targeted active column
      const activeColumns = {
        ...state.activeColumns,
        [action.column]: !state.activeColumns[action.column],
      };

      return {
        ...state,
        activeColumns,
      };
    }
    case ACTIONS_UI_TOGGLE_INCLUDE_OPEN_STATUS: {
      const toggled = !state.includeOpenStatus;
      return {
        ...state,
        includeOpenStatus: toggled,
      };
    }
    default:
      return state;
  }
}
